module.exports = __webpack_public_path__ + "img/d6.183808c1.jpg";